import React from "react";
import styled from "styled-components";
import CollectionItem from "./CollectionItem";
import { ArrowBack } from "@mui/icons-material"
import TooltipIconButton from "components/TooltipIconButton";
import SidebarHeader from "components/Sidebar/layout/SidebarHeader";

const Title = styled.h2`
  color: white;
  margin-bottom: 30px;
`;

export const collections_descriptions = {
  'Panorama': { text: 'Street-level equirectangular images', icon: 'satellite' },
  'Imagery': { text: 'Orthorectified mosaic of nadir frames', icon: 'hd' },
  'Frame': { text: 'Single nadir image frame', icon: 'hd' },
  'North': { text: 'Single North facing image frame', icon: 'hd' },
  'East': { text: 'Single East facing image frame', icon: 'hd' },
  'South': { text: 'Single South facing image frame', icon: 'hd' },
  'West': { text: 'Single West facing image frame', icon: 'hd' },
  'DEM': { text: 'Digital Elevation Model', icon: 'filter_hdr' },
  'DSM': { text: 'Digital Surface Model', icon: 'filter_hdr' },
};

const Collections = ({ onClose, goToDetailPage, onBack }) => {
  const collections = window.demonstrable_collections.map((collection, index) => {
    const collection_description = collections_descriptions[collection.name];
    if (collection_description) return { value: index, title: collection.name, text: collection_description.text, icon: collection_description.icon }
    return null;
  }).filter(collection => collection !== null);

  collections.sort((a, b) => {
    const indexA = Object.keys(collections_descriptions).indexOf(a.title);
    const indexB = Object.keys(collections_descriptions).indexOf(b.title);
    return (indexA === -1 ? 1000 : indexA) - (indexB === -1 ? 1000 : indexB);
  });

  return (
    <>
      <SidebarHeader onClose={onClose}>
        <TooltipIconButton title="Back" ariaLabel="back" placement="bottom" onClick={onBack} size={44}>
          <ArrowBack />
        </TooltipIconButton>
      </SidebarHeader>
      <Title>Collections</Title>
      {collections.map((collection, index) => (
        <CollectionItem
          key={index}
          collection={collection}
          goToDetailPage={goToDetailPage}
        />
      ))}
    </>
  );
};

export default Collections;